import '@core/scripts/app.js';
import '@header/scripts/header.js';
import '@footer/scripts/footer.js';

import './initializers/update-url-on-product-change';
import './initializers/preselect-single-item-option';

// lets save our mouse position for our product image slider to decide if it should zoom immediately
// best way to get the mouse position on page load before all modules are loaded
function saveFirstMousePosition(event) {
    if (!window.pageLoadMousePosition) {
        window.pageLoadMousePosition = {
            x: event.clientX,
            y: event.clientY
        };
    }
}
document.body.addEventListener('mouseenter', saveFirstMousePosition, {passive: true});
document.body.addEventListener('mousemove', saveFirstMousePosition, {passive: true});

